module.exports = __webpack_public_path__ + "static/BrandonGrotesque-BoldItalic-76443d908e60d2bb94d3032ad8765d27.ttf";